import { Injectable, Injector } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppInjectorService {
  private static instance: AppInjectorService;
  private injector: Injector;

  static getInstance() {
      if (!AppInjectorService.instance) {
        AppInjectorService.instance = new AppInjectorService();
      }

      return AppInjectorService.instance;
  }

  private constructor() {}

  setInjector(injector: Injector) {
      this.injector = injector;
  }

  getInjector(): Injector {
      return this.injector;
  }
}
